import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import { TBrandCar } from '@/selectors/getBrandCar';
import { Disclaimers, TSortedDisclaimers } from '@/selectors/getCarDisclaimers';
import { getCreditCalcFormState } from '@/selectors';
import { TOOLTIP_TEXT } from '@/constants';
import { config, format, WidgetMode } from '@/utils';
import Icon from '../Icon';
import Tooltip from '../Tooltip';

import style from './style.module.scss';

type TProps = {
  car: TBrandCar;
  disclaimers: TSortedDisclaimers;
};

const CarPrice: FC<TProps> = ({ car, disclaimers }) => {
  const { hidePrefixPrice } = config.all()

  const creditCalcFormState = useSelector(getCreditCalcFormState);
  const creditPrice = creditCalcFormState?.credits.monthPayment;
  const {
    summOfSelectedDiscountsWithoutTradeInPrice,
    carPriceDiscountedWithoutTradeInPrice,
    dealerCarPriceDiscountedWithoutTradeInPrice,
    price,
    dealerPrice,
  } = car!.extra;

  const isDealerMode = WidgetMode.isDealerMode();

  const TooltipPrice = (
    <Tooltip title={TOOLTIP_TEXT.price} placement="bottom">
      <Icon name="info" className="ml-2" />
    </Tooltip>
  );

  return car ? (
    <div className={style.priceWrap}>
      <div className={style.carPrice}>
        {summOfSelectedDiscountsWithoutTradeInPrice ? (
          <>
            <meta itemProp="price" content={`${isDealerMode ? dealerCarPriceDiscountedWithoutTradeInPrice : carPriceDiscountedWithoutTradeInPrice}`}/>
            <meta itemProp="priceCurrency" content="RUB"/>
            <link itemProp="availability" href="http://schema.org/InStock" />

            <p className={style.descr}>
              Цена с учетом выгод
              <sup>{disclaimers.get(Disclaimers.final)?.sortOrder}</sup>
              {TooltipPrice}
            </p>
            <div className={cn(style.price, style.discountPrice)}>
              {format.price(
                isDealerMode
                  ? dealerCarPriceDiscountedWithoutTradeInPrice
                  : carPriceDiscountedWithoutTradeInPrice
              )}{' '}
              Руб.
            </div>
            <div className={style.oldPrice}>
              {!hidePrefixPrice && <span>от</span>} {format.price(isDealerMode ? dealerPrice : price)}
            </div>
          </>
        ) : (
          <>
            <p className={style.descr}>
              <meta itemProp="price" content={`${isDealerMode ? dealerPrice : price}`}/>
              <meta itemProp="priceCurrency" content="RUB"/>
              <link itemProp="availability" href="http://schema.org/InStock" />

              Цена
              <sup>{disclaimers.get(Disclaimers.price)?.sortOrder}</sup>
              {TooltipPrice}
            </p>
            <div className={style.price}>
              {!hidePrefixPrice && <span>от</span>} <span>{format.price(isDealerMode ? dealerPrice : price)}</span>{' '}
              Руб.
            </div>
          </>
        )}
      </div>
      {creditPrice && (
        <div className={style.creditPrice}>
          <p className={style.descr}>
            Ежемесячно
            <Tooltip title={TOOLTIP_TEXT.monthly} placement="bottom">
              <Icon name="info" className="ml-2" />
            </Tooltip>
          </p>
          <div className={style.price}>
              {!hidePrefixPrice && <span>от</span>} {creditPrice} руб.
          </div>
        </div>
      )}
    </div>
  ) : null;
};

export default CarPrice;
